import { styled } from '@mui/material/styles'
import { MenuItem } from '@mui/material'
import type { SxProps, Theme } from '@mui/material'
import Box from '@/components/common/Box'
import {
	colors,
	typography,
	spacing,
	radius,
	shadows,
	sizing,
	focusVisible,
} from '@/styles/designTokens'

export const PillRoot = styled('button', {
	shouldForwardProp: (prop) =>
		prop !== 'isInteractive' && prop !== 'fullWidth' && prop !== 'compact',
})<{ isInteractive?: boolean; fullWidth?: boolean; compact?: boolean }>(
	({ isInteractive, fullWidth, compact }) => ({
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		gap: spacing.sm,
		height: compact ? undefined : sizing.buttonHeight,
		padding: compact ? 0 : `${spacing.sm}px ${spacing.lg}px`,
		borderRadius: compact ? 0 : radius.pill,
		border: 'none',
		outline: compact ? 'none' : `1px solid ${colors.border}`,
		outlineOffset: 0,
		backgroundColor: compact ? 'transparent' : colors.surfaceWhite,
		fontFamily: typography.fontFamily,
		flexShrink: 0,
		cursor: isInteractive ? 'pointer' : 'default',
		width: fullWidth ? '100%' : undefined,
		maxWidth: fullWidth ? '100%' : sizing.schedulePillMaxWidth,
		'&:focus-visible': {
			outline: `${focusVisible.outline} ${colors.overlayHeavy}`,
			outlineOffset: focusVisible.outlineOffset,
		},
	}),
)

export const PillLabel = styled('span')({
	fontSize: typography.fontSizeMd,
	lineHeight: typography.lineHeightMd,
	color: colors.textPrimary,
	display: 'inline-flex',
	alignItems: 'baseline',
	gap: spacing.xs,
	minWidth: 0,
	overflow: 'hidden',
})

export const PillLabelBold = styled('span')({
	fontWeight: typography.fontWeightBold,
	minWidth: 0,
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
})

export const PillLabelNormal = styled('span')({
	fontWeight: typography.fontWeightRegular,
	flexShrink: 0,
	whiteSpace: 'nowrap',
})

export const PillIconWrap = styled(Box)({
	marginLeft: 'auto',
	display: 'inline-flex',
	flexShrink: 0,
})

export const DropdownItem = styled(MenuItem)({
	fontFamily: typography.fontFamily,
	fontSize: typography.fontSizeMd,
	paddingTop: spacing.md,
	paddingBottom: spacing.md,
	paddingLeft: spacing.xl,
	paddingRight: spacing.xl,
})

export const dropdownPaperSx: SxProps<Theme> = {
	mt: 0.5,
	borderRadius: `${radius.dropdown}px`,
	boxShadow: shadows.dropdown,
	minWidth: sizing.moreMenuMinWidth,
}
